exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}.sf-loader{position:relative;width:100%;height:100%}.sf-loader__overlay{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background:var(--loader-overlay-background, var(--c-white))}.sf-loader__spinner{stroke:var(--loader-spinner-stroke, var(--c-primary))}\n", ""]);

// exports
